export const RESET_TOKEN_CHECKER = 'RESET_TOKEN_CHECKER';
